import React from 'react';
import styled from 'react-emotion';
import DefaultMenu from '../menu';
import DefaultHeader from '../header';
import DefaultFooter from '../footer';

const Layout = styled('div')({
  label: 'layout',
  display: 'flex',
  flexDirection: 'column',
  width: '100vw',
  height: '100vh',
  margin: '0 auto',
  maxWidth: '1200px',
  '& > :first-child': {
    zIndex: -1,
  },
}, ({ theme }) => ({
  ...theme.typography.body,
  ...theme.media.grid({
    paddingLeft: '10px',
    paddingRight: '10px',
    display: 'grid',
    gridTemplateColumns: '9em auto 0px',
    gridTemplateRows: '100px auto 24px',
    ...theme.media.shortScreen({
      gridTemplateRows: '60px auto 24px',
    }),
    gridGap: '0 20px',
    gridTemplateAreas: `
      "header header ."
      "menu content ."
      "footer footer ."
    `,
    '& > :first-child': {
      gridArea: 'header',
      zIndex: 2,
    },
    '& > :last-child': {
      gridArea: 'footer',
    },
    '& > :nth-child(2)': {
      gridArea: 'menu',
      zIndex: 0,
    },
    '& > :nth-child(3)': {
      gridArea: 'content',
    }
  }),
}));

export default ({menu = DefaultMenu, header = DefaultHeader, footer = DefaultFooter, children}) => {
  const Menu = menu;
  const Header = header;
  const Footer = footer;

  return (
      <Layout>
        <Header/>
        <Menu/>
        {children}
        <Footer/>
      </Layout>
  );
};



// WEBPACK FOOTER //
// ./src/structure/layout/layout.js